import type { LicensedProducts } from '@atlassian/jira-shared-types';

export const licensedProductsToString: (arg1: LicensedProducts) => string = (licensedProducts) =>
	Object.keys(licensedProducts)
		.map((productKey) => (licensedProducts[productKey] ? productKey : ''))
		.join(', ');
